/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AccessTokenDetails = {
    properties: {
        token: {
            type: 'string',
            isNullable: true,
        },
        tokenType: {
            type: 'string',
            isNullable: true,
        },
        tokenExpires: {
            type: 'string',
            format: 'date-time',
        },
        refreshToken: {
            type: 'string',
            isNullable: true,
        },
        refreshTokenExpires: {
            type: 'string',
            format: 'date-time',
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
        },
    },
};